import React from "react";
import reportsClasses from "./index.module.css";
import moment from "moment";

function DownloadTable({ data, styles, style, emptyHeaders, emptyMessage = "No result found" }) {
    const hasData = data && data.length > 0;

    if (!hasData && (!emptyHeaders || emptyHeaders.length === 0)) return null;

    const keys = hasData ? Object.keys(data[0]) : emptyHeaders;

    const formatValue = (key, value) => {
        if (!value && value !== 0) return "NA";
        if (key === "TransactionDate") {
            // Parse ISO and format as DD-MM-YYYY
            const m = moment(value);
            return m.isValid() ? m.format("DD-MM-YYYY") : value;
        }
        return value;
    };

    return (
        <div className={reportsClasses["Table"]}>
            <table style={{ ...styles, ...style }}>
                <thead>
                    <tr>
                        {keys.map((key, index) => (
                            <th key={index}>{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {hasData ? (
                        data.map((item, rowIndex) => (
                            <tr key={rowIndex}>
                                {keys.map((k, colIndex) => {
                                    const raw = item[k];
                                    if (k === "Invoice") {
                                        const inv = formatValue(k, raw);
                                        if (
                                            inv &&
                                            inv !== "NA" &&
                                            inv !== "NA.pdf" &&
                                            inv !== "NA"
                                        ) {
                                            // if Invoice looks like a filename or has PDF, link to assumed invoice path OR full url if provided
                                            let href = raw;
                                            // if raw is just a filename, attempt to construct path under static or S3 if needed
                                            if (
                                                !/^https?:\/\//i.test(raw) &&
                                                raw !== "NA"
                                            ) {
                                                // try build URL relative to static invoices (best effort)
                                                href = `${process.env.REACT_APP_BASE_URL}/uploads/invoices/${raw}`;
                                            }
                                            return (
                                                <td key={colIndex}>
                                                    <a
                                                        className={
                                                            reportsClasses.invoiceButton
                                                        }
                                                        href={href}
                                                        target="_blank"
                                                        rel="noreferrer">
                                                        View Invoice
                                                    </a>
                                                </td>
                                            );
                                        }
                                        return <td key={colIndex}>NA</td>;
                                    }

                                    if (k === "Type") {
                                        const typeVal = (raw || "")
                                            .toString()
                                            .toLowerCase();
                                        const cls =
                                            typeVal === "credited"
                                                ? reportsClasses.typeCredited
                                                : typeVal === "debited"
                                                ? reportsClasses.typeDebited
                                                : "";
                                        return (
                                            <td key={colIndex} className={cls}>
                                                {formatValue(k, raw)}
                                            </td>
                                        );
                                    }

                                    return (
                                        <td key={colIndex}>
                                            {formatValue(k, raw)}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={keys.length} style={{ textAlign: "center", padding: "20px", fontWeight: "500", color: "#666" }}>
                                {emptyMessage}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default DownloadTable;
